import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ErrorHandler } from '@playbookux/playbook-web-core';

import {
  Modal,
  Container,
  Title,
  Radio,
  ContainerRadioGroup,
  RadioContainer,
  ButtonCancel,
  ButtonSave,
  ContainerBottom,
} from './styles';

const ChangeStatusDialog = (props) => {
  const {
    status,
    open,
    onClose,
    onClickSave,
    loading,
    error,
    statuses,
  } = props;

  const [newStatus, setNewStatus] = useState(null);

  useEffect(() => {
    if (status) {
      setNewStatus(status);
    }
  }, [status]);

  const handleChange = (e, { value }) => {
    setNewStatus(value);
  };

  const handleSave = () => {
    onClickSave(newStatus);
  };

  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Container>
        <Title>
          Change Status
        </Title>
        <ContainerRadioGroup>
          {statuses.map((sts) => (
            <RadioContainer key={sts.value}>
              <Radio
                name={sts.text}
                value={sts.value}
                checked={newStatus === sts.value}
                onChange={handleChange}
              />
              {sts.text}
            </RadioContainer>
          ))}

        </ContainerRadioGroup>

        {error && (
          <ErrorHandler
            error={error}
            defaultMessage="Error while saving."
          />
        )}

        <ContainerBottom>
          <ButtonCancel onClick={onClose}>
            Cancel
          </ButtonCancel>

          <ButtonSave
            onClick={handleSave}
            loading={loading}
            disabled={loading}
          >
            Save
          </ButtonSave>

        </ContainerBottom>
      </Container>
    </Modal>
  );
};

ChangeStatusDialog.propTypes = {
  status: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onClickSave: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.arrayOf(PropTypes.object),
  statuses: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.value,
  })).isRequired,
};

ChangeStatusDialog.defaultProps = {
  open: false,
  loading: false,
  error: null,
};

export default ChangeStatusDialog;
